export default "__VITE_ASSET__7dbd2016__$_?nuxt_component=async&nuxt_component_name=SvgoLaravel__"